import { render, staticRenderFns } from "./douyin3.vue?vue&type=template&id=30a95882&scoped=true&"
import script from "./douyin3.vue?vue&type=script&lang=js&"
export * from "./douyin3.vue?vue&type=script&lang=js&"
import style0 from "./douyin3.vue?vue&type=style&index=0&id=30a95882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a95882",
  null
  
)

export default component.exports